import React, { useEffect, useMemo, useState } from 'react';
import img1 from '../../../assets/nbrestaurants1.png';
import locationIcon from '../../../assets/locationImg.svg';
import star from '../../../assets/Star.png';
import { useTranslation } from 'react-i18next';
import Filters from './filters';
import './Restaurantnearyou.css';
import Skeleton from '@mui/material/Skeleton';
import axiosUserInstance from '../../../axiosUserInstance';
import OrderPopop from '../../../Components/OrderPopop';

export default function Restaurantnearyou() {
    const { t } = useTranslation();
    const [restaurantData, setRestaurantData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [rating, setRating] = useState(''); 
    const [vegNonVeg, setVegNonVeg] = useState('');
    const [openPopop, setOpenPopop] = useState(false);
    const [vendorId, setVendorId] = useState(null);
    const [RestaurantName, setRestaurantName] = useState(null);
    const [RestaurantAddress, setRestaurantAddress] = useState(null);
    const [vendorRating, setVendorRating] = useState(null);
    const [vendorDistance, setVendorDistance] = useState(null);
    const [vendorRatingCount, setVendorRatingCount] = useState(null);
    const [coordinate, setCoordinate] = useState(null);

    const location = () => {
        const stored = localStorage.getItem('selectedLocation');
        if (stored) {
            try {
                const parsed = JSON.parse(stored);
                if (parsed?.lat && parsed?.lng) {
                    setCoordinate({ lat: parsed.lat, lng: parsed.lng });
                }
            } catch (error) {
                console.error('Invalid selectedLocation in localStorage:', error);
            }
        }
    };

    useEffect(() => {
        location();
    }, []);

    const handleNavigation = (vendor) => {
        setVendorId(vendor?.VendorID);
        setRestaurantName(vendor?.Vendor_Name);
        setOpenPopop(!openPopop);
        setRestaurantAddress(vendor?.V_Address || '');
        setVendorRating(vendor?.AvgRating || 0);
        setVendorDistance(vendor?.Distance_in_Miles || 0);
        setVendorRatingCount(vendor?.Vendor_Review_User_Count || 0);
    };
    
    const { ratingQuery, vegQuery } = useMemo(() => {
        return {
            ratingQuery: rating ? rating : '', 
            vegQuery: vegNonVeg || '',
        };
    }, [rating, vegNonVeg]);
    
    useEffect(() => {
        const getRestaurantNearYou = async () => {
            try {
                let response;
                if(coordinate){
                    response = await axiosUserInstance.get(
                        `/posts/nearbyRestaurants?location=${coordinate?.lat},${coordinate?.lng}&pageNo=1&pageSize=10&vegNonVeg=${vegQuery}&rating=${ratingQuery}`, {skipAuth: true}
                    );
                } else {
                    response = await axiosUserInstance.get(
                        `/posts/nearbyRestaurants?pageNo=1&pageSize=10&vegNonVeg=${vegQuery}&rating=${ratingQuery}`, {skipAuth: true}
                    );
                }
                setRestaurantData(response?.data?.vendors);
            } catch (error) {
                console.error('Error fetching restaurants', error);
            } finally {
                setIsLoading(false);
            }
        };
        getRestaurantNearYou();
    }, [ratingQuery, vegQuery, coordinate]);


    return (
        <div className="restaurantnearyou-Main-container-11">
            <div className="restaurantnearyou-head-container-11">
                <span className="restaurantnearyou-head-text-111">
                    {t('homescreen.restaurant-near-you-title')}
                </span>
                <Filters setRating={setRating} setVegNonVeg={setVegNonVeg}></Filters>
            </div>
            <div className="restaurantnearyou-card-container-111" >
                <div className="justify-content-center">
                    {isLoading
                        ? [...Array(10)].map((_, index) => (
                            <div key={index} className="restaurantnearyou-card-111">
                                <div className="restaurantnearyou-image-container-111">
                                    <Skeleton variant="rounded" width='100%' height={150} />
                                </div>
                                <div className="restaurants-data">
                                    <Skeleton variant="text" width={80} height={20} />
                                    <Skeleton variant="text" width={50} height={20} />
                                </div>
                            </div>
                        ))
                        : restaurantData && restaurantData?.length > 0 ? (
                            restaurantData?.map((restaurant, index) => (
                                <div
                                    key={index}
                                    className="restaurantnearyou-card-111"
                                    onClick={() => handleNavigation(restaurant)}
                                >
                                    <div className="restaurantnearyou-image-container-111">
                                        <img
                                            className="restaurantnearyou-image-111"
                                            src={restaurant?.FeatureImage || img1}
                                            alt="restaurant img"
                                        />
                                    </div>
                                    <div className="restaurants-data">
                                        <h6 className="restaurantnearyou-name-11">
                                            <span className="restaurantnearyou-text-111">
                                                {restaurant?.Vendor_Name}
                                            </span>
                                        </h6>
                                        <div className="Food-search-restaurant-footer">
                                            <div className="location-miles-container">
                                                <img 
                                                    src={locationIcon} 
                                                    alt="location" 
                                                    style={{
                                                        width: '20px',
                                                        height: '20px'
                                                    }}
                                                />
                                                <span className='Food-search-restaurant-dist'>
                                                    {restaurant?.Distance_in_Miles?.toFixed(1)} miles
                                                </span>
                                            </div>
                                            <div className='Food-dist-layout'>
                                                <img
                                                    className='Food-search-rest-star-icon-image'
                                                    src={star}
                                                    alt='search-rest-star icon'
                                                />
                                                <span className='Food-search-rest-reviews'>
                                                    {(restaurant?.AvgRating ?? 0)?.toFixed(1)} ratings
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ):(
                            <div className="no-data-found" style={{margin:'50px 0'}}>No Restaurants found</div>
                        )
                    }
                </div>
            </div>
            <div>
                {openPopop && 
                    <OrderPopop
                        restaurantName={RestaurantName}
                        handleClose={()=> {
                            setTimeout(() => {
                                setOpenPopop(!openPopop);
                            }, 500);
                        }}
                        vendorID={vendorId}
                        rating={vendorRating}
                        vendorAddress={RestaurantAddress}
                        vendorDistance={vendorDistance}
                        user_Rating_count={vendorRatingCount}
                    />
                }
            </div>
        </div>
    );
}
